import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    'Supabase credentials not configured. Auth features will be disabled.',
    'Set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env'
  );
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        // Token management - never expire
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        // Configurar storage para usar localStorage (mais persistente)
        storage: window.localStorage,
        // Detectar mudanças de sessão
        storageKey: 'refind-auth-token',
        // Flow type para melhor compatibilidade com OAuth
        flowType: 'pkce',
      },
    })
  : null;

export const isSupabaseConfigured = () => Boolean(supabase);

